exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideSelectorContainer .slideSelectorWrapper[data-v-08fd90b2]{color:#000}", ""]);

// exports
